import gql from 'graphql-tag';

export const rejectedDuplicateFileFragment = gql`
  fragment rejectedDuplicateFileFragment on RejectedDuplicateFile {
    dokkioClass
    id
    fileContentMD5
  }
`;
export default rejectedDuplicateFileFragment;
